import Note from "../../../model/note/Note";
import * as moment from "moment";
import AccountingNote from "../../../model/invoice/note/AccountingNote";

/**
 * Fetch notes successful action.
 */
export const NOTES_FETCHED = "NOTES_FETCHED";
export type NOTES_FETCHED = { leadId: string, notes: Note[] }

/**
 * Create note successful action.
 */
export const NOTE_CREATED = "NOTE_CREATED";
export type NOTE_CREATED = { leadId: string, note: Note }

/**
 * Update note successful action.
 */
export const NOTE_UPDATED = "NOTE_UPDATED";
export type NOTE_UPDATED = { leadId: string, note: Note }

/**
 * Delete note successful action.
 */
export const NOTE_DELETED = "NOTE_DELETED";
export type NOTE_DELETED = { leadId: string, noteId: string }

/**
 * Add note reminder successful action.
 */
export const NOTE_REMINDER_ADDED = "NOTE_REMINDER_ADDED";
export type NOTE_REMINDER_ADDED = { leadId: string, noteId: string, reminderDate: moment.Moment }

/**
 * Fetch job notes successful action.
 */
export const JOB_NOTES_FETCHED = "JOB_NOTES_FETCHED";
export type JOB_NOTES_FETCHED = { jobId: string, notes: Note[] }

/**
 * Create job note successful action.
 */
export const JOB_NOTE_CREATED = "JOB_NOTE_CREATED";
export type JOB_NOTE_CREATED = { jobId: string, note: Note }

/**
 * Update job note successful action.
 */
export const JOB_NOTE_UPDATED = "JOB_NOTE_UPDATED";
export type JOB_NOTE_UPDATED = { jobId: string, note: Note }

/**
 * Delete job note successful action.
 */
export const JOB_NOTE_DELETED = "JOB_NOTE_DELETED";
export type JOB_NOTE_DELETED = { jobId: string, noteId: string }

/**
 * Add job note reminder successful action.
 */
export const JOB_NOTE_REMINDER_ADDED = "JOB_NOTE_REMINDER_ADDED";
export type JOB_NOTE_REMINDER_ADDED = { jobId: string, noteId: string, reminderDate: moment.Moment }

/**
 * Fetch invoice notes successful action.
 */
export const INVOICE_NOTES_FETCHED = "INVOICE_NOTES_FETCHED";
export type INVOICE_NOTES_FETCHED = { invoiceId: string, notes: AccountingNote[] }

/**
 * Create invoice note successful action.
 */
export const INVOICE_NOTE_CREATED = "INVOICE_NOTE_CREATED";
export type INVOICE_NOTE_CREATED = { invoiceId: string, note: AccountingNote }

/**
 * Update invoice note successful action.
 */
export const INVOICE_NOTE_UPDATED = "INVOICE_NOTE_UPDATED";
export type INVOICE_NOTE_UPDATED = { invoiceId: string, note: AccountingNote }

/**
 * Delete invoice note successful action.
 */
export const INVOICE_NOTE_DELETED = "INVOICE_NOTE_DELETED";
export type INVOICE_NOTE_DELETED = { invoiceId: string, noteId: string }
